export function constructSnippet({
  choiceIndex,
  selectedChoice,
}: {
  choiceIndex: number;
  selectedChoice: string;
}) {
  let codeSnippet = `// We start with a labeled array:
let fruits = ['apple', 'banana', 'cherry'];`;

  if (choiceIndex === 0) {
    codeSnippet = `${codeSnippet}

// ⚠️⚠️⚠️⚠️
// Pick a different option from the list above
// to see how it translates in code!`;
  } else {
    codeSnippet = `${codeSnippet}

// ...And then we point this label at a new value:
fruits = ${selectedChoice};`;
  }

  return codeSnippet;
}
